import {makeStyles} from '@material-ui/core/styles'
import TableGridDiv from '../../2compounds/Tables/TableGridDiv'
import TableHeaderRow from '../../2compounds/Tables/TableHeaderRow'
import TableHeaderCell from '../../2compounds/Tables/TableHeaderCell'
import TableBody from '../../2compounds/Tables/TableBody'
import TableBodyRow from '../../2compounds/Tables/TableBodyRow'
import TableBodyCell from '../../2compounds/Tables/TableBodyCell'
import React from 'react'
import {Text} from '../../1elements'

const OptionalColumnsTable = ({optionalColumnList}) => {
    const classes = useStyles()
    const columns = [
        {label: 'Column', position: 'span 2'},
        {label: 'Description', position: 'span 5'},
        {label: 'Format', position: 'span 5'},
    ]

    return (
        <>
            <Text type={'bulkImportRuleHeader4'}>Optional Columns</Text>
            <TableGridDiv className={classes.root}>
                {/*  Table Header  */}
                <TableHeaderRow>
                    {columns.map((column)=>(
                        <TableHeaderCell gridColumn={column.position}
                                         key={column.label}
                                         label={column.label}  />
                    ))}
                </TableHeaderRow>
                {/*  Table Body  */}
                <TableBody className={classes.tableBody}>
                    {optionalColumnList.map((optionalColumn, index) => {
                        const {columnName, description, format, limit, example} = optionalColumn
                        return(
                            <TableBodyRow isOpen={true} key={index} className={classes.tableRow}>
                                <TableBodyCell gridColumn={columns[0].position} className={classes.tableCell} fontSize={'14px'}>
                                    <b>{columnName}</b>
                                </TableBodyCell>
                                <TableBodyCell gridColumn={columns[1].position} className={classes.tableCell} fontSize={'14px'}>
                                    {description}
                                </TableBodyCell>
                                <TableBodyCell gridColumn={columns[2].position} className={classes.tableCell} fontSize={'14px'}>
                                    {format && (<><b>Format</b>: {format}<br/></>)}
                                    {limit && (<><b>Limit</b>- {limit}<br/></>)}
                                    {example && (<><b>E.g.</b> {example}<br/></>)}
                                </TableBodyCell>
                            </TableBodyRow>
                        )})}
                </TableBody>

            </TableGridDiv>
        </>
    )
}

export default OptionalColumnsTable

const useStyles = makeStyles({
    tableCell: {
        whiteSpace: 'normal',
        overflow: 'visible',
        textOverflow: 'clip'
    },
    tableBody: {
        maxHeight: '130px'
    },
    tableRow: {
        height: '130px'
    }
})